import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]

import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useSessionStore } from "@/store/useSessionStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'AvatarComponent',
  props: {
    radius: { default: "rounded-4" },
    size: { default: "avatar-xxl" }
  },
  setup(__props: any) {



const { session } = storeToRefs(useSessionStore());

const placeholder = computed(() =>
  session.value?.gender === "female"
    ? require("@/assets/img/avatars/1.png")
    : require("@/assets/img/avatars/2.png"),
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["avatar cursor-pointer shadow", [_ctx.radius, _ctx.size]])
  }, [
    (_unref(session)?.formatted_profile_image?.uri)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _unref(session)?.formatted_profile_image?.uri,
          class: _normalizeClass(["avatar-img", _ctx.radius])
        }, null, 10, _hoisted_1))
      : (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: placeholder.value,
          class: _normalizeClass(["avatar-img", _ctx.radius])
        }, null, 10, _hoisted_2))
  ], 2))
}
}

})